import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Layer } from '../models/layer';

@Injectable({
  providedIn: 'root'
})
export class LayerService {
  private layerState = new BehaviorSubject<Layer>({
    bsn: true,
    modeles: false,
    piezometres: false,
    pluviometres: false,
    hydrometrie: false,
    // Initialisation des propriétés de désactivation
    bsnDisabled: false,
    modelesDisabled: false,
    piezometresDisabled: false,
    pluviometresDisabled: false,
    hydrometrieDisabled: false,
  });

  currentLayerState$ = this.layerState.asObservable();

  updateLayerState(newState: Layer): void {
    this.layerState.next(newState);
  }

  // Nouvelle méthode pour mettre à jour les propriétés de désactivation des couches
  updateLayerDisabledState(disabledState: Partial<Layer>): void {
    const currentState = this.layerState.getValue();
    const updatedState = { ...currentState, ...disabledState };
    this.layerState.next(updatedState);
  }

  getLayerState(): Layer {
    return this.layerState.getValue();
  }
}
